import type { Traducao } from '../textos.ts'

/** Os nomes que a dica dá ao próprio botão (D-203). O texto da dica continua na origem. */
export const TEXTOS_DA_DICA = {
  sobre: { 'pt-BR': 'Sobre', 'es-419': 'Acerca de', 'en-US': 'About' },
  indisponivel: {
    'pt-BR': 'Por que não está disponível:',
    'es-419': 'Por qué no está disponible:',
    'en-US': 'Why it is unavailable:',
  },
} satisfies Readonly<Record<string, Traducao>>
